import { Icon } from "./Icon.tsx";

/**
 * "Add element" menu trigger icon (AddElementMenu.tsx) — deliberately NOT
 * the "small element shape + small corner-plus badge" convention every
 * individual Add*Icon uses, since a plain shape in this slot read as just
 * another element icon rather than a menu trigger. A big centered plus in
 * a rounded square instead — the generic "open an add menu" glyph.
 */
export function AddElementIcon() {
  return (
    <Icon>
      <rect x="3" y="3" width="18" height="18" rx="4" />
      <path d="M12 8v8M8 12h8" />
    </Icon>
  );
}
